import { OnInit, Directive } from "@angular/core";
import {Observable} from 'rxjs';
import { LocalStorage } from "./helpers/local-storage";

import Form from "./Form";
import Swal from "sweetalert2";
import {AlertResponseService, TypeAlertService} from './services/alert-response.service';

@Directive()
export default class BaseComponent extends Form implements OnInit {
  infoAlert: TypeAlertService | null
  infoAlert$: Observable<TypeAlertService>;
  user = LocalStorage.getItem("currentUser");
  companyId = LocalStorage.getItem("id");

  ngOnInit() {}

  alert(title: string, icon: any) {
    Swal.fire({
      type: icon,
      title: title,
      timer: 3500,
      confirmButtonText: "Confirmar",
      customClass: {
        confirmButton: "btn btn-secondary  rounded-20",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
  }

  testAlert() {
    this.alert("Apareceu", "success");
  }

  get isAdmin() {
    return this.user.roles === "ADMINISTRADOR";
  }

  setInfoAlert(alertResponseService: AlertResponseService, info: TypeAlertService) {
    alertResponseService.handleSubscribe();
    alertResponseService.emit(info);
  }

  phoneMask = ["(", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
}
